import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

import moment from "moment";

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')
    store.dispatch('fetchUserPosts')
    store.dispatch('fetchUserPostsAll')
    store.dispatch('fetchPendingPosts')

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })

    // realtime updates from our posts collection
    /*
    fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
      // check if created by currentUser
      let createdByCurrentUser
      if (querySnapshot.docs.length) {
        createdByCurrentUser = store.state.currentUser.uid == querySnapshot.docChanges()[0].doc.data().userId ? true : false
      }

      // add new posts to hiddenPosts array after initial load
      if (querySnapshot.docChanges().length !== querySnapshot.docs.length
        && querySnapshot.docChanges()[0].type == 'added' && !createdByCurrentUser) {

        let post = querySnapshot.docChanges()[0].doc.data()
        post.id = querySnapshot.docChanges()[0].doc.id

        store.commit('setHiddenPosts', post)
      } else {
        let postsArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          postsArray.push(post)
        })
        store.commit('setPosts', postsArray)
        
      }
    })*/
  } /*else {*/
  let approvalStatus = "approved";
  fb.postsCollection
    .orderBy('createdOn', 'desc')
    .where('status', '==', approvalStatus)
    .limit(25).onSnapshot(querySnapshot => {
    if (querySnapshot.docChanges().length !== querySnapshot.docs.length
      && querySnapshot.docChanges()[0].type == 'added') {

      let post = querySnapshot.docChanges()[0].doc.data()
      post.id = querySnapshot.docChanges()[0].doc.id

      store.commit('setHiddenPosts', post)
    } else {
      let postsArray = []
      querySnapshot.forEach(doc => {
        let post = doc.data()
        post.id = doc.id
        postsArray.push(post)
      })
      store.commit('setPosts', postsArray)
    }
  })
  /*}*/
})

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    posts: [],
    userPosts: [],
    userPostsAll: [],
    pendingPostsAll: [],
    hiddenPosts: [],
  },
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
      commit('setPosts', null)
      commit('setUserPosts', null)
      commit('setUserPostsAll', null)
      commit('setPendingPostsAll', null)
      commit('setHiddenPosts', null)
    },

    updatePost({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        let postID = data.postID
        let year = data.year;
        let odometer = data.odometer;
        let odometermetric = data.odometermetric
        let range = data.range;
        let rangemetric = data.rangemetric
        let battery = data.battery;
        let charging = data.charging;
        let acceleration = data.acceleration;
        let condition = data.condition;
        let vehiclecountry = data.vehiclecountry
        let vehiclelocation = data.vehiclelocation
        let phone = data.phone;
        let email = data.email;
        let content = data.content
        let price = data.price
        let pricetype = data.pricetype
        let currency = data.currency
        let industry = data.industry
        let status = data.status

        console.log("updatePost() postID: " + postID);
        /*
        console.log("updatePost() Uid: " + state.currentUser.uid);
        */
        fb.postsCollection.doc(postID)
        //.where('userId', '==', state.currentUser.uid)
        .update({ year, odometer, odometermetric, range, rangemetric, battery, charging, acceleration, condition, vehiclecountry, vehiclelocation, phone, email, content, price, currency, pricetype, industry, status })
        
        .then(post => {
          console.log("db success: ")
          console.log("resolve post: " + post.title)
          resolve(post)
        })
        .catch(err => {
          console.log("db error: " + err)
          reject(err);
        })
      })
    },

    fetchUserPosts({ commit, state }) {
      fb.postsCollection
        .where('userId', '==', state.currentUser.uid)
        .orderBy('createdOn', 'desc')
        .limit(5)
        .onSnapshot(querySnapshot => {
        
        let userPostsArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          userPostsArray.push(post)
        })
        store.commit('setUserPosts', userPostsArray)
      //}).catch(err => {
        //console.log(err)
      })
    },

    fetchUserPostsAll({ commit, state }) {
      fb.postsCollection
        .where('userId', '==', state.currentUser.uid)
        .orderBy('createdOn', 'desc')
        .onSnapshot(querySnapshot => {
        
        let userPostsAllArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          userPostsAllArray.push(post)
        })
        store.commit('setUserPostsAll', userPostsAllArray)
      //}).catch(err => {
        //console.log(err)
      })
    },
    
    fetchPendingPosts({ commit, state }) {
      let approvalStatus = "pending";
      fb.postsCollection
        .where('status', '==', approvalStatus)
        .orderBy('createdOn', 'desc')
        .onSnapshot(querySnapshot => {
        
        let pendingPostsAllArray = []
        querySnapshot.forEach(doc => {
          let post = doc.data()
          post.id = doc.id
          pendingPostsAllArray.push(post)
        })
        store.commit('setPendingPostsAll', pendingPostsAllArray)
      //}).catch(err => {
        //console.log(err)
      })
    },

    fetchUserProfile({ commit, state }) {
      fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
        commit('setUserProfile', res.data())
      }).catch(err => {
        console.log(err)
      })
    },
    
    updateProfile({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        let name = data.name
        let position = data.position
        let location = data.location
        let type = data.type

        fb.usersCollection.doc(state.currentUser.uid).update({ name, position, location, type }).then(user => {
          // update all posts by user to reflect new name
          fb.postsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
            docs.forEach(doc => {
              fb.postsCollection.doc(doc.id).update({
                userName: name
              })
            })
          })
          // update all comments by user to reflect new name
          fb.commentsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
            docs.forEach(doc => {
              fb.commentsCollection.doc(doc.id).update({
                userName: name
              })
            })
          }),
          resolve(user)
          console.log("db success: ")
        }).catch(err => {
          reject(err);
          console.log("db error: " + err)
        })
      })
      
    },

    checkProfileTagHandle ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        let taghandle = data.taghandle
        fb.usersCollection.where('taghandle', '==', taghandle).get().then(response => {
          resolve(response);  
        }).catch(err => {
          reject(err);
          console.log(err)
        })   
      })
    },

    updateProfileTagHandle ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        let taghandle = data.taghandle
        fb.usersCollection.doc(state.currentUser.uid).update({ taghandle }).then(response => {
          console.log("Response");
          resolve(response);  
        }, error => {
          console.log("Rejected");
          reject(error);
        })
      })
    },
  },

  getters: {
    postsWithScore: state => {
      return state.posts.map(post => {
        let date = post.createdOn.toDate();
        let start = moment(String(date));
        let now = moment(new Date()); 
        let diff = now.diff(start);
        let hours = moment.duration(diff).asHours()
        let gravity = 1.8;
        let likes = post.likes;
        let score = likes / hours^gravity
        //let score = (likes-1) / (hours+2)^gravity
        if (score <= 1) {
          score = 1;
        }
        return {
          ...post,
          score: score,
        }
      })
    },
  },

  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPosts(state, val) {
      if (val) {
        state.posts = val
      } else {
        state.posts = []
      }
    },

    setPendingPostsAll(state, val) {
      if (val) {
        state.pendingPostsAll = val
      } else {
        state.pendingPostsAll = []
      }
    },

    setUserPosts(state, val) {
      if (val) {
        state.userPosts = val
      } else {
        state.userPosts = []
      }
    },
    setUserPostsAll(state, val) {
      if (val) {
        state.userPostsAll = val
      } else {
        state.userPostsAll = []
      }
    },

    setHiddenPosts(state, val) {
      if (val) {
        // make sure not to add duplicates
        if (!state.hiddenPosts.some(x => x.id === val.id)) {
          state.hiddenPosts.unshift(val)
        }
      } else {
        state.hiddenPosts = []
      }
    }
  }
})
